import { html } from 'fxjs/es';

export const fn = (text) => html`
  <div id="mobile_text_input_81102">
    <input type="text" name="text_input" value="${text}" />
  </div>
`;
